<div class='competitions-container'>

  <h2> Marketplace </h2>

  <app-product-list [configuration]='marketPlace'></app-product-list>

</div>
